import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15 8L12 5L9 8L9.707 8.707L11.5 6.914V19H12.5V6.914L14.293 8.707L15 8Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ThinLong02Up"
);
